import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import { getIsVisibleInLocale } from "../../../../services/links"
import colors from "../../../../styles/colors"
import fonts from "../../../../styles/fonts"
import breakpoints from "../../../../styles/breakpoints"

const List = styled.div`
  display: grid;
  gap: 12px;
  align-items: flex-start;
  align-content: flex-start;
`

const StyledLink = styled(Link)`
  ${fonts.ivyStyleLight};
  text-decoration: none;
  color: inherit;
  font-size: 12px;
  color: ${(props) => (props.featured ? colors.lightGreen : colors.trueBlack)};
  line-height: 1.16;
  text-align: left;
  display: inline-block;
  padding: 0;
  text-transform: lowercase;
  text-decoration: ${(props) => (props.active ? "underline" : "none")};
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }

  @media (min-width: ${breakpoints.xl}) {
    font-size: 14px;
  }
`

const StyledButton = styled.button`
  ${fonts.ivyStyleLight};
  padding: 0;
  border: none;
  font-size: 12px;
  color: ${(props) => (props.featured ? colors.lightGreen : colors.trueBlack)};
  line-height: 1.16;
  padding: 12px 30px;
  text-align: left;
  text-transform: lowercase;
  padding: 0;
  background: transparent;
  cursor: pointer;
  text-decoration: ${(props) => (props.active ? "underline" : "none")};
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }

  @media (min-width: ${breakpoints.xl}) {
    font-size: 14px;
  }
`

const StyledA = styled.a`
  ${fonts.ivyStyleLight};
  text-decoration: none;
  color: inherit;
  font-size: 12px;
  color: ${(props) => (props.featured ? colors.lightGreen : colors.trueBlack)};
  line-height: 1.16;
  text-align: left;
  display: inline-block;
  text-transform: lowercase;
  padding: 0;
  text-decoration: ${(props) => (props.active ? "underline" : "none")};
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }

  @media (min-width: ${breakpoints.xl}) {
    font-size: 14px;
  }
`

const HeaderTitle = styled.h3`
  ${fonts.ttNormsProBold};
  text-transform: uppercase;
  font-size: 12px;
  line-height: 16px;
`;

const LinkList = ({ links, handleBespokePopupClick, header }) => {
  return (
    <List>
      {header && <HeaderTitle>{header}</HeaderTitle>}
      {links?.map((link, index) => {
        const isVisible = getIsVisibleInLocale(link.locale)

        if (!isVisible) return null

        if (link.openBespokeForm) {
          return (
            <StyledButton
              onClick={handleBespokePopupClick}
              featured={link.isFeatured ? 1 : 0}
              key={index}
            >
              {link.title}
            </StyledButton>
          )
        }

        if (link.externalLink) {
          return (
            <StyledA
              href={link.externalLink}
              featured={link.isFeatured ? 1 : 0}
              key={index}
            >
              {link.title}
            </StyledA>
          )
        }
        return (
          <StyledLink
            to={link.link}
            featured={link.isFeatured ? 1 : 0}
            key={index}
          >
            {link.title}
          </StyledLink>
        )
      })}
    </List>
  )
}

export default LinkList
